<template>
	<div id="HomePage">
		<!-- 手机 -->
		<div id="bigData" class="container-fuild">
			<div class="row bigData-container">
				<div class="">
					<div class="title">
						<div>
							数智云农夫铺子
						</div>
					</div>
					<div class="info">
						数智化农夫铺子丨10W+商品丨API接入<br /> 阳光采购丨农夫铺子一级资质
					</div>
				</div>

			</div>
			<div class="xf">
				<div>国家标准委员会<br>农夫铺子备案企业</div>
				<div>农夫铺子管理服务<br>企业一级资质</div>
				<div>ISO28000农夫铺子<br>安全管理认证</div>
			</div>

		</div>

		<!-- 手表 -->
		<div id="bigData2" class="container-fuild">
			<div class="sb_cont">
				<div class="title2">
					<span>
						数智化云农夫铺子核心优势
					</span>
				</div>
				<div class="info2">

				</div>
			</div>
			<div class="row">
				<div class="">
					<img class="img-responsive2" src="@/assets/img/sb_bg.png">
				</div>
			</div>
		</div>


		<!-- 平板 -->
		<div id="bigData3" class="container-fuild">
			<div class="title2">
				<span>
					数智商业生态核心能力
				</span>
			</div>
			<div class="row bigData-container3">

				<div class="content_info">
					<div @click="show = true" :class="show ?'content1':'content2'">01 丨 中小微企业平台</div>
					<div @click="show = false" :class="show ?'content2':'content1'">02 丨 源头生产企业</div>
				</div>

				<div v-if="show" class="bigData3_right">
					<img src="@/assets/img/qy_bg11.png" alt="" />
					<div class="bigData3_right_ms">
						<div>
							解决企业采购问题
						</div>
						<span>
							做为中小微企业数智化转型升级服务的重要组成部分，农夫铺子云农夫铺子为各中小微企业平台提供API对接、一键代发、企业集采、特色招商等数智化农夫铺子服务及增值服务
						</span>
					</div>
				</div>

				<div v-else class="bigData3_right">
					<img src="@/assets/img/qy_bg1.png" alt="" />
					<div class="bigData3_right_ms">
						<div>
							解决企业销售问题
						</div>
						<span>
							通过创新的F2S2B2C模式，为源头生产企业提供一站式农夫铺子数智化销售服务。通过全国200余家区域运营商，负责开发本地各类源头企业直供产品的农夫铺子入驻服务。为中小微企业平台提供更具性价比的农夫铺子特色产品。
						</span>
					</div>
				</div>

			</div>
		</div>



		<!-- 耳机 -->
		<div id="bigData4" class="container-fuild">
			<div class="sb_cont sb_cont4">
				<div class="title2">
					<span>
						数智商业生态核心业务
					</span>
				</div>
			</div>
			<div class="row">
				<div class="bigData4_info">
					<div class="list list_bg1">
						<div>
							农夫铺子特色产品
						</div>
						<span>
							乡村良品丨一县一品丨全球甄选丨农夫铺子 <br /> 区块链溯源丨特色产品共享店丨特色产品团购
						</span>
					</div>
					<div class="list list_bg2">
						<div>
							企业数智化综合服务
						</div>
						<span>
							商城系统丨REP/CRM <br />智慧城市公众号/小程序丨全生态APP开发
						</span>
					</div>
					<div class="list list_bg3">
						<div>
							数智云农夫铺子
						</div>
						<span>
							数智化农夫铺子丨10W+商品<br /> API接入阳光采购丨农夫铺子一级资质
						</span>
					</div>
					<div class="list list_bg4">
						<div>
							数智新零售业务
						</div>
						<span>
							元宇宙技术丨大数据分析<br /> 精准营销丨线上线下融合丨短视频直播
						</span>
					</div>
					<div class="list list_bg5">
						<div>
							AI人工智能业务
						</div>
						<span>
							智能售货机丨智能炒菜机<br /> 智慧广告屏丨宏眸智能化设备丨微灵AI直播
						</span>
					</div>
					<div class="list list_bg6">
						<div>
							智慧康养
						</div>
						<span>
							智能监测丨智能评估丨智能调理<br /> 艾幸健康馆丨万慈安健康平价超市
						</span>
					</div>
					<div class="list list_bg7">
						<div>
							文旅产业
						</div>
						<span>
							万慈安康养温泉酒店 <br />旅居康养
						</span>
					</div>
					<div class="list list_bg8">
						<div>
							教育培训
						</div>
						<span>
							学历教育丨职业技能认证<br /> 在出国留学深造丨企业培训
						</span>
					</div>
					<div class="list list_bg9">
						<div>
							创投孵化
						</div>
						<span>
							技术投资丨品牌投资<br /> 实业投资产业园投资丨创新项目孵化
						</span>
					</div>
				</div>
			</div>
		</div>

		<!-- 吹风机 -->
		<div id="bigData6" class="container-fuild">
			<div class="sb_cont">
				<div class="title2">
					<span>
						数万“爆款”任由选择
					</span>
				</div>
			</div>
			<div class="row">
				<div class="">
					<img class="pp_logo" src="@/assets/img/pp_logo.png" alt="智能护眼仪">
				</div>
			</div>
		</div>


	</div>
</template>
<script>
	import {
		WOW
	} from 'wowjs';
	export default {
		name: "HomePage",
		data() {
			return {
				show: true,
				navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
				menuName: "首页",
				menuClass: "glyphicon glyphicon-menu-down",
				navList: [{
						name: "首页",
						path: "/",
						children: []
					},
					{
						name: "手机",
						path: "/",
						children: []
					},
					{
						name: "手表",
						path: "/",
						children: []
					},
					{
						name: "平板",
						path: "/",
						children: []
					},
					{
						name: "耳机",
						path: "/",
						children: []
					},
					{
						name: "吹风机",
						path: "/",
						children: []
					},
					{
						name: "护眼仪",
						path: "/",
						children: []
					},
					{
						name: "APP",
						path: "/",
						children: []
					},
					{
						name: "关于我们",
						path: "/",
						children: []
					}
				]

			};
		},
		methods: {
			navClick(index, name) {
				console.log(index);
				this.navIndex = index;
				sessionStorage.setItem('navIndex', index)
				this.menuName = name;
				if (index == '1') {
					this.scrollTo('bigData')
				} else if (index == '2') {
					this.scrollTo('bigData2')
				} else if (index == '3') {
					this.scrollTo('bigData3')
				} else if (index == '4') {
					this.scrollTo('bigData4')
				} else if (index == '5') {
					this.scrollTo('bigData5')
				} else if (index == '6') {
					this.$router.push({
						path: '/companyIntroduction'
					});
				}
			},
			scrollTo(id) {
				// 根据传入的 id 获取目标元素
				const element = document.getElementById(id);
				if (element) {
					// 调用 scrollIntoView 方法滚动到目标元素
					element.scrollIntoView({
						behavior: 'smooth', // 平滑滚动
						block: 'start' // 滚动到元素顶部对齐
					});
				}
			},
			menuClick() {
				if (this.menuClass == "glyphicon glyphicon-menu-down") {
					this.menuClass = "glyphicon glyphicon-menu-up";
				} else {
					this.menuClass = "glyphicon glyphicon-menu-down";
				}
			}
		},
		mounted() {
			/* wowjs动画 */
			var wow = new WOW({
				boxClass: 'wow',
				animateClass: 'animated',
				offset: 0,
				mobile: true,
				live: true
			})
			wow.init();
		},
	};
</script>
<style scoped>
	/* 顶部 */
	#header {
		background: none;
		transition: all ease 0.6s;
		position: absolute;
		top: 0;
		/* width: 100%; */
		margin-left: 15%;
	}

	#header .header-top {
		height: 50px;
		color: #fff;
		font-size: 12px;
		line-height: 50px;
		background: #474747;
	}

	/* 顶部的图标 */
	#header .header-top span {
		margin: 0 8px;
	}

	/* 导航栏 */
	#header .header-nav {
		height: 110px;
	}

	/* 导航栏logo */
	#header .header-nav .header-nav-logo {
		width: 100px;
		height: 100%;
		float: left;
		position: relative;
	}

	/* 导航栏logo图片 */
	#header .header-nav .header-nav-logo img {
		width: 35.67px;
		height: 40px;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		margin: auto;
	}

	/* 导航栏 导航容器 */
	#header .header-nav-fixed .header-nav-wrapper {
		line-height: 50px;
	}

	#header .header-nav .header-nav-wrapper {
		line-height: 110px;
		float: right;
		margin: 0;
		max-width: 800px;
	}

	/* 导航栏 每个导航 */
	#header .header-nav .header-nav-wrapper>li {
		float: left;
		margin: 0 15px;
		position: relative;
	}

	/* 导航栏 每个导航下面的 a 链接 */
	#header .header-nav .header-nav-wrapper>li>a {
		color: #333;
		font-size: 15px;
		font-weight: bold;
		padding: 15px 0;
		position: relative;
	}

	/* 导航栏 每个导航下面的 a 链接的下划线 */
	#header .header-nav .header-nav-wrapper>li>a>i {
		display: block;
		position: absolute;
		bottom: -2px;
		left: 50%;
		width: 0;
		height: 2px;
		opacity: 0;
		transition: all 0.6s ease;
		/* background-color: #FF791F; */
	}

	/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
	#header .header-nav .header-nav-wrapper>li>a>span {
		font-size: 12px;
		transition: transform ease 0.5s;
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
	#header .header-nav .header-nav-wrapper>li>a:hover {
		color: #FF791F;
		text-decoration: none;
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
	#header .header-nav .header-nav-wrapper>li>a:hover .underline {
		opacity: 1;
		width: 100%;
		left: 0;
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
	#header .header-nav .header-nav-wrapper>li>a:hover span {
		transform: rotate(180deg);
	}

	/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
	#header .header-nav .header-nav-wrapper>li.active>a {
		color: #FF791F;
		text-decoration: none;
		/* border-bottom: 2px solid #FF791F; */
	}

	/* 导航栏 每个导航下面的二级导航容器 */
	#header .header-nav .header-nav-wrapper>li>dl {
		display: none;
		position: absolute;
		width: 168px;
		top: 80%;
		left: 0;
		z-index: 999999;
		box-shadow: 0 0 3px 1px #ccc;
		background: #fff;
	}

	/* 导航栏 每个导航下面的二级导航容器的每个导航 */
	#header .header-nav .header-nav-wrapper>li>dl>dt {
		width: 100%;
		padding: 10px;
		border-bottom: 1px solid #ccc;
	}

	/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
	#header .header-nav .header-nav-wrapper>li>dl>dt>a:hover {
		text-decoration: none;
	}

	/* 导航栏 滑上一级导航显示二级导航 */
	#header .header-nav .header-nav-wrapper>li:hover dl {
		display: block;
	}

	#header .header-nav .header-nav-wrapper>li>dl>dt:hover {
		cursor: pointer;
		background: #ccc;
	}

	.glyphicon {
		display: none;
	}



	@media screen and (max-width: 997px) {
		#header {
			width: 100%;
			margin: 20px auto;
			padding: 0;
		}

		.header-nav {
			width: 761px;
		}

		#header .header-nav-m {
			/* position: relative; */
		}

		/* 导航栏logo容器 */
		#header .header-nav-m .header-nav-m-logo {
			height: 80px;
			position: relative;
		}

		/* 导航栏logo图片 */
		#header .header-nav-m .header-nav-m-logo img {
			width: 30px;
			height: 33px;
			/* position: absolute; */
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			margin: auto;
		}

		/* 导航栏  菜单容器 */
		#header .header-nav-m .header-nav-m-menu {
			color: #fff;
			height: 50px;
			font-size: 20px;
			line-height: 50px;
			/* background: #474747; */
			/* position: absolute; */
		}

		#header .header-nav-m .header-nav-m-menu img {
			width: 30px;
			height: 30px;
		}

		/* 导航栏 菜单图标 */
		#header .header-nav-m .header-nav-m-menu-wrapper {
			position: absolute;
			top: 50%;
			right: 20px;
			margin-top: -20px;
			width: 50px;
			height: 40px;
			color: #fff;
			z-index: 999999;
			font-size: 12px;
		}

		/* 导航栏 */
		#header .header-nav-m .header-nav-m-wrapper {
			position: absolute;
			top: 75px;
			left: 0;
			width: 100%;
			background: #474747;
			z-index: 9999999;
		}

		/* 导航栏 每个导航 */
		#header .header-nav-m .header-nav-m-wrapper>li {
			height: 40px;
			line-height: 40px;
			border-bottom: 1px solid #ccc;
		}

		/* 导航栏 每个导航下面的 a 链接 */
		#header .header-nav-m .header-nav-m-wrapper>li>a {
			color: #fff;
			font-size: 15px;
			font-weight: bold;
			padding: 15px 0;
			position: relative;
		}

		/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
		#header .header-nav .header-nav-wrapper>li>a>span {
			font-size: 10px;
		}
	}

	@media screen and (max-width: 768px) {
		#header {
			padding: 20px;
			z-index: 1;
		}
	}

	.bigData-container {
		padding: 276px 16% 0;

	}

	.bg_span {
		color: #222222;
	}

	.pb_describe {
		color: #999999;
		font-size: 14px;
	}

	.pb_cont {
		margin-top: 120px;
		text-align: left;
		margin-left: 92px;
	}

	.bigData-container3 {
		width: 1300px;
		display: flex;
		margin: 0 auto;
	}

	.bigData4_info {
		width: 1315px;
		margin: 0 auto;
		margin-top: 80px;
	}

	.bigData4_info .list {
		display: inline-block;
		width: 30%;
		margin-right: 30px;
		margin-bottom: 25px;
		height: 200px;
		color: #FFFFFF;
		text-align: left;
		box-sizing: border-box;
		padding: 32px 0 0 40px;
	}

	.list_bg1 {
		background: url(https://zdboss.nfpzdigit.com/supplychain/list_bg1.png);
		background-size: 100% 100%;
	}

	.list_bg2 {
		background: url(https://zdboss.nfpzdigit.com/supplychain/list_bg2.png);
		background-size: 100% 100%;
	}

	.list_bg3 {
		background: url(https://zdboss.nfpzdigit.com/supplychain/list_bg3.png);
		background-size: 100% 100%;
	}

	.list_bg4 {
		background: url(https://zdboss.nfpzdigit.com/supplychain/list_bg4.png);
		background-size: 100% 100%;
	}

	.list_bg5 {
		background: url(https://zdboss.nfpzdigit.com/supplychain/list_bg5.png);
		background-size: 100% 100%;
	}

	.list_bg6 {
		background: url(https://zdboss.nfpzdigit.com/supplychain/list_bg6.png);
		background-size: 100% 100%;
	}

	.list_bg7 {
		background: url(https://zdboss.nfpzdigit.com/supplychain/list_bg7.png);
		background-size: 100% 100%;
	}

	.list_bg8 {
		background: url(https://zdboss.nfpzdigit.com/supplychain/list_bg8.png);
		background-size: 100% 100%;
	}

	.list_bg9 {
		background: url(https://zdboss.nfpzdigit.com/supplychain/list_bg9.png);
		background-size: 100% 100%;
	}

	.bigData4_info .list div {
		font-weight: bold;
		font-size: 24px;
		margin-bottom: 30px;
	}

	.bigData4_info .list span {
		font-size: 16px;
	}

	.bigData-container5 {
		padding: 100px 367px 0px 0;
		display: flex;
		justify-content: space-between;
	}

	.bigData3_right {
		background: #FFFFFF;
		box-shadow: 0px 0px 30px 0px rgba(255, 121, 31, 0.06);
		border-radius: 6px 6px 6px 6px;
		box-sizing: border-box;
		padding: 50px;
		display: flex;
		text-align: left;
		margin-left: 30px;
	}

	.bigData3_right_ms {
		margin-left: 50px;
	}

	.bigData3_right_ms div {
		font-weight: bold;
		font-size: 24px;
		color: #333333;
		margin-bottom: 15px;
	}

	.bigData3_right_ms span {
		font-size: 16px;
		color: #666666;
		line-height: 32px;

	}

	.bigData3_right img {
		width: 476px;
		height: 350px;
	}

	.content1 {
		width: 268px;
		height: 120px;
		text-align: center;
		line-height: 120px;
		color: #fff;
		font-size: 18px;
		background: #FF822E;
		border-radius: 6px 6px 6px 6px;
		margin-bottom: 30px;
	}

	#bigData6 .title2 {
		margin-top: 120px;
	}

	.rz_info {
		width: 1315px;
		display: flex;
		margin: 0 auto;
		margin-top: 120px;
	}

	.rz_info_left img {
		width: 420px;
		height: 344px;
		border-bottom: 1px solid #EBEBEB;
		padding-bottom: 50px;
		margin-bottom: 44px;
	}

	.rz_info_left {
		width: 480px;
		height: 480px;
		box-sizing: border-box;
		padding: 30px;
		background-color: #fff;
		box-shadow: 0px 0px 30px 0px rgba(255, 121, 31, 0.06);
		border-radius: 6px 6px 6px 6px;
		margin-right: 30px;
	}

	.rz_info_left div {
		font-size: 18px;
		color: #666666;
	}

	.rz_info_right {
		height: 480px;
	}

	.rz_info_right .lsit {
		display: inline-block;
		width: 225px;
		height: 225px;
		box-sizing: border-box;
		padding: 25px;
		background-color: #fff;
		margin-right: 20px;
		margin-bottom: 30px;
		box-shadow: 0px 0px 30px 0px rgba(255, 121, 31, 0.06);
		border-radius: 6px 6px 6px 6px;
		text-align: center;
		font-size: 14px;
		color: #666666;
	}

	.lsit img {
		width: 165px;
		height: 138px;
		padding-bottom: 20px;
		border-bottom: 1px solid #EBEBEB;
		margin-bottom: 20px;
	}

	.content2 {
		width: 268px;
		height: 120px;
		text-align: center;
		line-height: 120px;
		color: #333333;
		font-size: 18px;
		background: #F2F7FA;
		margin-bottom: 30px;
		border-radius: 6px 6px 6px 6px;
	}

	.pp_logo {
		width: 1315px;
		margin: 120px auto;
	}

	.title {
		display: flex;

	}

	.info {
		font-size: 18px;
		color: #fff;
		line-height: 25px;
		margin-top: 48px;
	}

	.info2 {
		line-height: 50px;
		margin-top: 59px;
	}

	.info3 {
		margin-top: 29px;
	}



	.title div {
		font-weight: bold;
		font-size: 64px;
		color: #FFFFFF;
	}

	/* 整体盒子 */
	#HomePage {
		width: 100%;
	}

	/* 轮播图 */
	#swiper {
		height: 600px;
	}

	#swiper .banner-swiper {
		width: 100%;
		height: 100%;
	}

	#swiper .banner-swiper .swiper-slide img {
		width: 100%;
		height: 100%;
	}

	#swiper .banner-swiper .swiper-slide {
		position: relative;
	}

	#swiper .banner-swiper .swiper-slide-title {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 999999999;
		width: 100%;
		height: 100%;
		color: #fff;
		background: rgba(51, 51, 51, 0.534);
		text-align: center;
		line-height: 80px;
	}

	#swiper .banner-swiper .swiper-slide-title>h1 {
		font-size: 50px;
		margin-top: 12%;
	}

	#swiper .banner-swiper .swiper-slide-title>p {
		font-size: 20px;
		margin-top: 1%;
		font-weight: 700;
	}

	/* 大数据管理系统 */
	#bigData {
		height: 900px;
		transition: all ease 0.6s;
		box-sizing: border-box;
		background-image: url(https://zdboss.nfpzdigit.com/supplychain/h_bg.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
	}

	#bigData2 {
		height: 900px;
		transition: all ease 0.6s;
		box-sizing: border-box;
		background: #F7F7F7;
		text-align: center;
		padding-top: 90px;
	}

	.xf {
		width: 1315px;
		height: 150px;
		display: flex;
		justify-content: space-around;
		position: absolute;
		bottom: -50px;
		left: calc((100% - 1315px) / 2);

	}

	.xf div {
		width: 410px;
		height: 150px;
		color: #444444;
		font-weight: 500;
		font-size: 24px;
		box-sizing: border-box;
		padding-top: 35px;
		text-align: center;
		box-shadow: 0px 0px 30px 0px rgba(255, 121, 31, 0.06);
		border-radius: 6px 6px 6px 6px;
		background-color: #fff;

	}

	#bigData3 {
		height: 900px;
		transition: all ease 0.6s;
		box-sizing: border-box;
		background: #FFFFFF;
		text-align: center;
		padding-top: 90px;
	}

	#bigData4 {
		height: 900px;
		transition: all ease 0.6s;
		box-sizing: border-box;
		background: #F7F7F7;
		text-align: center;
		padding-top: 60px;
	}


	.info2 {
		margin-top: 38px;
	}

	.sb_cont {
		text-align: center;

	}

	.title5 {
		font-weight: 800;
		font-size: 64px;
		margin-top: 130px;
	}

	.download {
		width: 50%;
		display: flex;
		justify-content: space-evenly;
		margin: 210px auto;
	}

	.download img {
		width: 64px;
		height: 64px;
		display: inline-block;
	}

	.title5 div {
		font-size: 40px;
		margin-top: 30px;
	}

	.title2 img {
		width: 248px;
		height: 46px;
		display: inline-block;
		margin-bottom: 20px;
	}

	.title2 span {
		font-weight: bold;
		font-size: 36px;
		color: #333333;
	}

	.img-responsive {
		width: 564px;
		height: 623px;
	}

	.img-responsive img {
		width: 100%;
		height: 100%;
	}

	.img-responsive2 {
		margin-top: 120px;
		width: 1315px;
		height: 599px;
		display: inline-block;
	}

	.img-responsive4 {
		width: 674px;
		height: 665px;
		display: inline-block;
	}

	.img-responsive7 {
		width: 674px;
		height: 580px;
		display: inline-block;
	}

	.img-responsive3 {
		width: 828px;
		height: 517px;
	}

	.img-responsive5 {
		width: 595px;
		height: 746px;
	}

	#bigData .bigData-title {
		padding-bottom: 10px;
		border-bottom: 1px solid #ccc;
	}

	#bigData p {
		font-size: 14px;
		color: #333;
		line-height: 2rem;
	}

	#bigData .bigData-device {
		margin: 50px 0 20px;
	}



	#contactUs .contactUs-container {
		padding-top: 50px;
	}

	#contactUs .contactUs-container button {
		width: 300px;
		height: 50px;
		margin-top: 40px;
	}

	#contactUs .contactUs-container .contactUs-contactWay span {
		display: inline-block;
		width: 48px;
		height: 48px;
		margin: 30px;
	}


	/* 客户评价 */
	#customer {
		padding: 50px 0;
		box-sizing: border-box;
		background: #efefef;
		transition: all ease 0.6s;
	}

	#customer .customer-title {
		font-size: 30px;
		color: rgb(102, 102, 102);
		margin: 0 0 30px;
	}

	#customer .customer-block {
		background: #fff;
		padding: 30px;
	}

	#customer .customer-logo img {
		width: 94px;
		height: 94px;
		border: 1px solid #ccc;
	}

	#customer .customer-yh img {
		width: 34px;
		height: 34px;
	}

	#customer .customer-content1 {
		padding-bottom: 20px;
		border-bottom: 1px solid #0ce9f1;
	}

	#customer .customer-content2 {
		padding-top: 20px;
	}

	/* 为什么选择我们 */
	#whyChooseUs {
		padding: 100px;
	}

	#whyChooseUs .whyChooseUs-title {
		margin-bottom: 50px;
	}

	#whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
		font-size: 25px;
		font-weight: 500;
	}

	#whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
		font-size: 14px;
	}

	#whyChooseUs .server-block {
		padding: 50px 20px;
		border: 1px solid #ccc;
		border-bottom: 5px solid #ccc;
	}

	#whyChooseUs .server-block img {
		width: 48px;
		height: 48px;
	}

	#whyChooseUs .server-block>p {
		font-size: 20px;
		margin: 30px 0;
	}

	#whyChooseUs .server-block>div {
		color: #ccc;
	}

	@media screen and (max-width:1200px) {
		.bigData-container {
			padding: 200px 9% 0;
		}

	}

	@media (min-width:1200px) and (max-width:1400px) {
		.container {
			width: 870px;
		}
	}

	@media (min-width:1401px) and (max-width:1600px) {
		.container {
			width: 1000px;
		}
	}

	@media (min-width:768px) and (max-width:1199px) {
		.visible-md-block {
			display: block !important
		}
	}

	@media (min-width:1200px) {
		.img-responsive3 {
			width: 700px;
			height: 400px;
		}

		.pb_cont {
			margin-top: px;
			margin-left: 50px;
		}

		.bigData-container {
			padding: 276px 20% 0;
		}

		.bigData-container3 {
			padding: 139px 10px 0px 0;
		}

		.bigData-container5 {
			padding: 0px 10px 0px 0;
		}
	}

	/* 媒体查询（手机） */
	@media screen and (max-width: 768px) {

		.title img {
			width: 124px;
			height: 23px;
			margin-top: -5px;
		}

		.title2 img {
			width: 124px;
			height: 23px;
			margin-top: 10px;
		}

		.title div,
		.title2 span {
			font-size: 18px;
			font-weight: 500;
		}

		.title {
			display: block;

		}

		.title img,
		.title div {
			display: inline-block;
			margin-left: 0;
			font-size: 32px;
		}

		.title5 {
			margin-top: 30px;
			font-size: 32px;
		}

		.title5 div {
			margin-top: 15px;
			font-size: 20px;

		}

		.download {
			width: 100%;
			margin: 100px auto 0;
			font-size: 14px;

		}

		.sb_cont {
			margin-top: 0px;
		}

		.sb_cont4 {
			margin-top: 0px;
		}

		.download img {
			width: 32px;
			height: 32px;
			margin-left: 10px;
			display: inline-block;
		}


		.info {
			margin-top: 18px;
			font-size: 12px;
		}

		.info2 {
			margin-top: 20px;
			line-height: 25px;
		}

		.info3 {
			margin-top: 0px;
		}

		.img-responsive {
			width: 220px;
			height: 245px;
			position: absolute;
			bottom: 0px;
			right: 50px;
		}

		#swiper {
			height: 200px;
		}

		#bigData {
			padding: 100px 32px 0 32px;
			height: 300px;
			position: relative;
			text-align: center;
		}

		.xf {
			display: none;
		}

		#bigData2,
		#bigData3,
		#bigData4 {
			width: 90%;
			border-radius: 20px;
			background: #fff;
			height: 100%;
			margin: 20px auto;
			padding-top: 30px;
		}

		#bigData6 {
			width: 90%;
			border-radius: 20px;
			background: #fff;
			margin: 20px auto;
			text-align: center;
		}

		#bigData6 .title2 {
			margin-top: 0px;
		}


		.img-responsive2 {
			width: 100%;
			height: 160px;
			margin-top: 0;
		}

		.img-responsive3 {
			width: 300px;
			height: 200px;
		}

		.img-responsive4 {
			width: 270px;
			height: 274px;
		}

		.img-responsive5 {
			width: 270px;
			height: 274px;
		}

		.bigData3_right {
			display: inline-block;
			margin-left: 0;
			padding: 10px;
		}

		.bigData3_right img {
			width: 100%;
			height: 175px;
		}

		.bigData4_info {
			width: 100%;
			margin-top: 30px;
		}

		.bigData4_info .list {
			width: 45%;
			margin-right: 2.5%;
			height: 79px;
			padding: 10px;
		}

		.bigData4_info .list div {
			font-weight: 500;
			font-size: 13px;
			margin-bottom: 5px;
		}

		.bigData4_info .list span {
			display: none;
		}

		.list_bg9 {
			display: none !important;
		}

		.pp_logo {
			width: 100%;
			margin: 30px 0;
		}

		.rz_info {
			width: 100%;
			display: inline-block;
			margin: 0px;
		}

		.rz_info_left {
			width: 100%;
			height: 100%;
			margin-right: 0;
		}

		.rz_info_left div {
			font-weight: 500;
			font-size: 12px;
			color: #666666;
		}

		.rz_info_right {
			height: 100%;
		}

		.rz_info_right .lsit {
			width: 45%;
			height: 100%;
			padding: 15px 5px;
			margin-right: 2.5%;
			margin-bottom: 20px;
			font-size: 12px;
		}

		.lsit img {
			width: 100%;
			height: 83px;
			padding: 0;
			border: none;
		}


		.rz_info_left img {
			width: 100%;
			height: 100%;
			padding: 0;
			border: none;
			margin-bottom: 20px;
		}

		.bigData3_right_ms {

			margin-left: 10px;
		}

		.bigData3_right_ms div {
			font-weight: 500;
			font-size: 14px;
			color: #333333;
			margin-top: 15px;
		}

		.bigData3_right_ms span {
			font-size: 12px;
			color: #666666;
			line-height: 27px;
		}

		.img-responsive7 {
			width: 270px;
			height: 250px;
		}

		.bigData-container3 {
			width: 100%;
			display: inline-block;
			padding: 0;
		}

		.bigData-container5 {
			display: inline-block;
			padding: 0;
		}

		.content_info {
			display: flex;
			justify-content: space-between;
			margin-top: 30px;
		}

		.content1 {
			width: 45%;
			height: 30px;
			text-align: center;
			line-height: 30px;
			color: #fff;
			font-size: 9px;
			background: #FF822E;
			border-radius: 3px;
			margin-bottom: 15px;
		}

		.content2 {
			width: 45%;
			height: 30px;
			text-align: center;
			line-height: 30px;
			color: #333333;
			font-size: 9px;
			background: #F2F7FA;
			margin-bottom: 15px;
			border-radius: 3px;
		}



		.pb_cont {
			margin: 30px auto;
			text-align: center;
		}

		.pb_cont6 {
			margin: 10px auto;
			text-align: center;
		}

		.bigData-container {
			padding: 0;
			display: block;
		}

		#bigData .bigData-title {
			font-size: 20px;
		}

		#bigData .bigData-device {
			font-size: 20px;
			margin: 10px 0 10px;
		}

		#contactUs {
			height: 200px;
			transition: all ease 0.6s;
		}

		#contactUs .contactUs-container {
			padding-top: 0;
		}

		#contactUs .contactUs-container h1 {
			font-size: 25px;
		}

		#contactUs .contactUs-container h3 {
			font-size: 18px;
		}

		#contactUs .contactUs-container button {
			width: 200px;
			height: 30px;
			margin-top: 20px;
		}

		#contactUs .contactUs-container .contactUs-contactWay span {
			display: inline-block;
			width: 28px;
			height: 28px;
			margin: 10px;
		}

		#customer {
			padding: 30px 0;
			box-sizing: border-box;
			background: #fff;
		}

		#customer .customer-title {
			font-size: 16px;
			font-weight: bold;
		}

		#customer .customer-logo img {
			width: 48px;
			height: 48px;
		}

		#customer .customer-block {
			padding: 30px;
		}

		#customer .customer-block>div {
			padding: 30px 0;
		}

		#whyChooseUs {
			padding: 20px 0;
			transition: all ease 0.6s;
		}

		#whyChooseUs .whyChooseUs-title p:nth-of-type(1) {
			font-size: 20px;
			font-weight: 700;
		}

		#whyChooseUs .whyChooseUs-title p:nth-of-type(2) {
			font-size: 12px;
		}

		#whyChooseUs .server-block {
			padding: 50px 0;
			border: 1px solid #ccc;
			border-bottom: 5px solid #ccc;
		}

		#whyChooseUs .server-block img {
			width: 48px;
			height: 48px;
		}

		#whyChooseUs .server-block>p {
			font-size: 20px;
			margin: 30px 0;
		}

		#whyChooseUs .server-block>div {
			color: #ccc;
		}
	}

	/* 媒体查询（平板） */
	@media screen and (min-width: 768px) and (max-width: 1200px) {

		#header {
			padding: 0;
		}

		.img-responsive {
			width: 335px;
			height: 400px;
		}

		.img-responsive img {
			width: 100%;
			height: 100%;
		}

		.img-responsive2 {
			width: 610px;
			height: 420px;
		}

		.img-responsive3 {
			width: 500px;
			height: 300px;
		}

		.img-responsive5 {
			width: 350px;
			height: 400px;
		}

		.img-responsive4 {
			width: 340px;
			height: 400px;
		}

		.img-responsive7 {
			width: 340px;
			height: 320px;
		}

		.header-nav {
			width: 761px;
		}

		.bigData-container3 {
			padding: 140px 70px 0px 0;
		}

		.bigData-container5 {
			padding: 30px 70px 0px 0;
		}

		.pb_cont {
			margin-top: 60px;
			margin-left: 50px;
		}

		#bigData {
			height: 600px;
			-webkit-transition: all ease 0.6s;
			transition: all ease 0.6s;
			-webkit-box-sizing: border-box;
			box-sizing: border-box;
			background-image: url(https://zdboss.nfpzdigit.com/supplychain/h_bg.png);
			background-position: center;
			background-repeat: no-repeat;
			background-size: cover;
		}

		#bigData2,
		#bigData3,
		#bigData4,
		#bigData5 {
			height: 600px;
			padding-top: 20px;
		}

		.title img,
		.title2 img {
			width: 165px;
			height: 34px;
			margin-top: 5px;
		}

		.title div {
			font-size: 33px;
			margin-left: 15px;
		}

		.title5 {
			font-size: 40px;
			margin-top: 100px;

		}

		.download {
			width: 100%;
			display: flex;
			justify-content: space-evenly;
			margin: 100px auto 0;
		}

		.title5 div {
			font-size: 24px;
			margin-top: 25px;

		}

		.info2 {
			margin-top: 10px;
		}

		.title2 span {
			font-size: 33px;
			margin-left: 15px;
		}

		#bigData .bigData-title {
			font-size: 30px;
		}

		#bigData .bigData-device {
			font-size: 30px;
			margin: 30px 0 15px;
		}

	}
</style>


// WEBPACK FOOTER //
// src/view/HomePage.vue